import axios from 'axios';
import {URL} from '../root';
import {DAO_CODE} from './_daoCode';
import {ErrorModel} from '../../models';

const FUNCTION_CODE = 'GET_DEAL_RECIPIENTS';

export async function getDealRecipients(
    userToken: string,
    dealId: number
) {
    try {
        const response = await axios.get(
            `${URL}/deals/${dealId}/related-payers/`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de récupération de la liste des destinataires de l\'affaire.',
            error: error
        });
    }
}
